var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battery-container"},[_c('span',{staticClass:"body",style:(_vm.bodyStyle)},[_c('span',[_vm._v(_vm._s(_vm.percentageTxt))])]),_c('span',{staticClass:"tip",style:(_vm.tipStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }